import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campP1FloorBudgetNew: FaireAdCampaignEntity = {
  token: "camp_p1_floor_budget_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_p1_floor_budget",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 200,
  startedRunningAt: "2024-10-07",
  segmentMetrics: {
    numCustomersAcquired: 0,
    salesDollars: 0,
    totalAdsSpendDollars: 5,
    cpaDollars: 0,
    bestEstimateSalesDollars: 0,
    bestEstimateRoas: 0,
  },
  performancePeriodTokens: [
    "perf_p1_floor_budget_new_202605",
    "perf_p1_floor_budget_new_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
